module.exports = __webpack_public_path__ + "img/gengxin2.8a6ee745.png";